import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {devConfig} from "../../../config/config"; // Importing development configuration

/**
 * MarketingVsRegistrosView class extends JetView to create a specific view for marketing vs registrations.
 */
export default class MarketingVsRegistrosView extends JetView {
	/**
	 * Configures the layout of the view.
	 * @returns {Object} The configuration object for the view.
	 */
	config(){
		const _ = this.app.getService("locale")._; // Localization service for translations
		return {
			type:"clean", // Setting the type of the view to clean
			rows:[
				{ template:_("Marketing Vs Registros"), type:"header", css:"webix_header chart_header" }, // Header template with localization
				{
					view:"chart", type:"scatter", // Scatter chart configuration
					localId:"chart2", // Local ID for referencing the chart
					xValue: "#register#", // X-axis value mapping
					value:"#value#", // Y-axis value mapping
					item:{
						borderColor:"#fff", // Item border color
						color:"#8664C6", // Item color
						shadow:false, // Shadow effect for items
						radius:7, // Radius of the items
						type:"d" // Type of the items
					},
					xAxis:{
						start:0, // Starting point of the X-axis
						lines:false, color:"#EDEFF0", // X-axis lines and color
						title:_("Registros") // Title for the X-axis with localization
					},
					yAxis:{
						start:0, // Starting point of the Y-axis
						step:200, // Step value for the Y-axis
						color:"#fff", lineColor:"#EDEFF0", // Y-axis color and line color
						title:_("Valor") // Title for the Y-axis with localization
					},
					tooltip:{
						template:"<b>Marketing: #marketing# </b><br> Registros: #register# Clicks: #value# " // Tooltip template for chart items
					},
				}
			]
		};
	}

	/**
	 * Initializes the view and sets up event listeners.
	 */
	init() {
		const cur_user = this.getParam("user", true); // Retrieve the current user parameter
		var vthis = this; // Preserve the context of 'this'
		
		// Event listener for marketing vs registrations statistics
		this.on(this.app,"statisticsAgent:marketingvsregistros",data => {
			vthis.$$("chart2").clearAll(); // Clear existing chart data
			vthis.$$("chart2").parse(data); // Parse new data into the chart
		});
		
		// Event listener for date changes
		this.on(this.app,"statisticsAgent:date2",date => {
			var dateRange=date; // Store the date range
			webix.ajax().headers({
				"Content-type": "application/json" // Set content type for the AJAX request
			}).post(devConfig.geturlApi() + "Agent/GetMarketingStats", '{ "AgentId":' + cur_user + ', "FromDateLocal":"' + dateRange.FromDateLocal + '", "ToDateLocal":"' + dateRange.ToDateLocal + '"}', {
				error: function (text, data, XmlHttpRequest) {
					webix.message(_("Error! ")); // Show error message on failure
				},
				success: function (text, data, XmlHttpRequest) {
					var data = JSON.parse(text); // Parse the response data
					vthis.$$("chart").clearAll(); // Clear existing chart data
					vthis.$$("chart").parse(data.result.charts.MediaStat.records); // Parse new data into the chart
				}
			});
		});
	}
}

// FILE DOCUMENTED
